import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const StackStyle = () => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
});

export const StackStyled = styled(Stack)(StackStyle);
